import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'

import PerPage from './PerPage'
import PageLinks from './PageLinks'
import AdministratorsCountQuery from '../../queries/AdministratorsCountQuery'

const Container = styled.div`
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Pagination = ({ data, currentPage, changePage, next, prev, first, perPage, changePerPage }) => {
  const { loading, error, administratorsCount } = data
  if (loading || error) {
    return null
  } else {
    const totalPages = Math.ceil(administratorsCount / perPage)
    return (
      <Container>
        <PageLinks
          currentPage={currentPage}
          totalPages={totalPages}
          next={next}
          last={() => changePage(totalPages)}
          first={first}
          prev={prev}
          changePage={changePage}
        />
        <PerPage
          perPage={perPage}
          changePerPage={changePerPage}
          totalRecords={administratorsCount}
          totalPages={totalPages}
        />
      </Container>
    )
  }
}

Pagination.displayName = 'Pagination'

Pagination.propTypes = {
  data: PropTypes.shape({
    administratorsCount: PropTypes.number,
    loading:             PropTypes.bool,
    error:               PropTypes.object
  }),
  changePage:    PropTypes.func.isRequired,
  changePerPage: PropTypes.func.isRequired,
  currentPage:   PropTypes.number.isRequired,
  first:         PropTypes.func.isRequired,
  next:          PropTypes.func.isRequired,
  perPage:       PropTypes.number.isRequired,
  prev:          PropTypes.func.isRequired
}

export default graphql(AdministratorsCountQuery, {
  options: OwnProps => ({
    variables: {
      role: OwnProps.role
    }
  })
})(Pagination)
